export enum BeneficiarySsnRouteFlow {
  HomeBeneficiarySsnCollection = "homeBeneficiarySsnCollection",
}

export type BeneficiarySsnRouteLocationState = {
  beneficiaryId: string;
  flow: BeneficiarySsnRouteFlow.HomeBeneficiarySsnCollection;
};

export type BeneficiarySsnFormValues = {
  ssn: string;
};
